import { createStore, applyMiddleware } from "redux";
import rootReducer from "../reducers/index";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../saga";
import { persistReducer } from 'redux-persist';
import storageSession from 'redux-persist/lib/storage/session';
import { CookieStorage } from 'redux-persist-cookie-storage';
import { OurCookieStorage } from "./OurCookieStorage";
import Cookies from 'cookies-js';
import { getDomain } from "../helpers/Tools";
import * as trueInitialState from "./trueInitialState";

//const persistConfig = {
//    key: 'root',
//    keyPrefix: '',
//    storage: storageSession
//};

//const persistSSOConfig = {
//    key: 'root',
//    keyPrefix: '',
//    whitelist: ["sso"],
//    storage: new CookieStorage(Cookies)
//};

    const sDomain = getDomain();
    console.log("Domain is: " + sDomain);


const configureStore = (serverData) => {
    //debugger;
    const persistOurConfig = {
        key: 'root',
        keyPrefix: '',
        storage: new OurCookieStorage(Cookies, {
            setCookieOptions: { domain: sDomain && sDomain === "localhost" ? null : sDomain, path: "/" },
            persistSSO: serverData ? serverData.persistSSO : null,
            persistSession: serverData ? serverData.persistSession : null, 
            persistDomain: serverData ? serverData.persistDomain : null,
            persitsPrayerFeature: serverData ? serverData.persistPrayerFeature : null,
            keyPrefix: serverData.environment + "-"
        })
    };

    //Immediately restoring state (from sessionStorage and/or cookies)
    let oCurrState = window.sessionStorage.getItem("root");
    if (oCurrState) {
        oCurrState = JSON.parse(oCurrState);
    }
    let oCookieDomain = Cookies.get(serverData.environment + "-root-Domain");
    let oState = trueInitialState.trueInitialState;
    if (oCookieDomain) {
        //debugger;
        oState = Object.assign(oState, JSON.parse(oCookieDomain)); // .domain = JSON.parse(oCurrState.domain);
    }
    else if (oCurrState) {
        oState.domain = JSON.parse(oCurrState.domain);
        if (oCurrState.localCache) {
            let oCache = JSON.parse(oCurrState.localCache);
            if (typeof oCache !== "undefined") {
                oState.localCache = oCache;
            }
            
        }
    }
    let sCorrelationID = Cookies.get("bsw-CorrelationId");
    
    //debugger;
    if (sCorrelationID && oState && oState.domain) {
        oState.domain.c = sCorrelationID;
    }

    // this is separate case for the if statement above -- reducer allows a session storage cache that survives navigates and refreshes
    if (oCurrState) {
        //debugger;
        if (oCurrState.localCache) {
            let oCache = JSON.parse(oCurrState.localCache);
            if (typeof oCache !== "undefined") {
                oState.localCache = oCache;
            }

        }
    }

    if (serverData) {
        oState.session.serverData = serverData;
    }
    //debugger;


    if (Object.keys(oState).length > 20) {


        // you're killin' me, Smalls.


        //debugger;
        //debugger;
        //debugger;
        //debugger;
        //alert("Stand down here and figure this out");
    }

    const sagaMiddleware = createSagaMiddleware();
    //console.log( "saga middleware created");

    const oPersistReducer = persistReducer(persistOurConfig, rootReducer);
    //console.log( "persist reducer created");
    const oStore = createStore(
        oPersistReducer,
        oState,
        applyMiddleware(sagaMiddleware)
    );
    //console.log( "store state = " + JSON.stringify( oStore.getState()));
    return {
        ...oStore,
        runSaga: sagaMiddleware.run(rootSaga).done.catch((err) => {
            // here we need to redirect to recover from a fatal error
            if (typeof window !== "undefined") {
                //debugger;
                if (window.location.pathname !== "/") {
                    //debugger;
                    window.location.assign("https://" + window.location.host + "/");
                }
                else {
                    window.document.body.outerHTML = "<H1>We are experiencing technical difficulties.</H1><br /><h2>Please retry your request in a few minutes.</h2>";
                }
            }
        })
    };

};

export default configureStore;
